import React, { useState } from "react";
import { Modal, Row, Col, Button, Form } from "react-bootstrap";

const AddRemarks = ({ onSubmitRemark }) => {
  const [showModal, setShowModal] = useState(false);
  const [discussion, setDiscussion] = useState("");
  const [nextDate, setNextDate] = useState("");

  const onApply = () => {
    const formData = { discussion, nextDate, isRemark: true };
    onSubmitRemark(formData);
    setShowModal(false);
  };

  return (
    <div>
      <Row className="mb-3">
        <Col md={12}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="#87cefa"
            className="bi bi-plus-circle"
            viewBox="0 0 16 16"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setShowModal(true);
            }}
          >
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
          </svg>
          <label className="ms-2 form-label" htmlFor="remark">
            Add Remark
          </label>
        </Col>
      </Row>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="md" // Medium size modal
      >
        <Modal.Body>
          <label className="form-label">Add Remark</label>
          <Form>
            <Row className="mb-3">
              <Col md={12}>
                <label className="form-label" htmlFor="discussion">
                  Discussion
                </label>
                <input
                  type="text"
                  id="discussion"
                  className="form-control"
                  placeholder="Enter discussion"
                  value={discussion}
                  onChange={(e) => setDiscussion(e.target.value)}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <label className="form-label" htmlFor="nextDate">
                  Next Date
                </label>
                <input
                  type="date"
                  id="nextDate"
                  className="form-control"
                  value={nextDate}
                  onChange={(e) => setNextDate(e.target.value)}
                />
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <button
                className="btn btn-info text-white rounded-pill px-4 py-2"
                style={{ fontSize: "0.9rem" }}
                onClick={onApply}
              >
                Add
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddRemarks;
